import Vue from 'vue';
/**
 * 统一处理 await/async 错误。
 * @param {Promise} promise
 */
export function awaitWrap(promise) {
  console.log('[awaitWrap]', promise);
  return promise.then((data) => {
    console.log('[awaitWrap] then');
    return [null, data];
  }).catch((err) => {
    console.log('[awaitWrap] catch', err);
    return [err, null];
  });
}

/**
 * ajax网络请求错误统一处理
 * 不会抛出异常，最终都收敛为 {code, msg} 的形式。
 * @param {Promise} promise
 */
export async function ajaxErrorCatch(promise, showToast?) {
  const [err, res] = await awaitWrap(promise);
  // 正确的进行了200返回
  if (res) {
    if (res.data) return res.data;
    return { code: -100000, msg: `网络错误（${res.status}）` };
  }

  if (err) {
    if (showToast) {
      Vue.prototype.$Toast({ text: '网络错误', type: 'error' });
    }

    return { code: -200000, msg: err || '网络错误' };
  }
}
